import React, { useCallback, useEffect, useState } from "react";
import "./ReachOutKitSCRO.css";
import Accordion from "react-bootstrap/Accordion";
import * as FeatherIcon from "react-feather";
import iq_api_v2, { addContactsToCampaign, addTempaltesToCampaign, createCampaign, userClientData } from "../../../../../../services/iqApiV2";
import {
  useTaskData,
  useTaskStatus,
} from "../../../../../../context/TaskStatusContext";
import GeneratingLoader from "../../../../genericComponents/uiElements/GeneratingLoader";
import { WSS_URL } from "../../../../../../config/apiConfig";
import { useParams } from "react-router-dom";
import { useUser } from "../../../../../../context/UserContext";
import ReactMarkdown from "react-markdown";
import SimpleDateField from "../../../../genericComponents/simpleTextField/SimpleDateField";
import SimpleTextField from "../../../../genericComponents/simpleTextField/SimpleTextField";
import SimpleTextAreaField from "../../../../genericComponents/simpleTextField/SimpleTextAreaField";
import SearchOrAddDropdown from "../../../../AutoNurture/SideCardsForAutoNurture/childCompsForNurtureCard/NurtureCampaignContact/SearchOrAddDropdown";
import { formatDateToYMD } from "../../../../../../utilities/dateUtils";
import SimpleThemedButton from "../../../../genericComponents/simpleTextField/SimpleThemedButton";
import { useBanner } from "../../../../../../context/BannerContext";
function ReachOutKitSCROV1({ opportunity_details, contact_name, contactId , oppId,linkedInUrl,contactJobTitle,contactDetail,setShowMoreModal}) {
  const TASK_ID = `tro_sidecard_reachout_${contactId}_${oppId}`;
  console.log("TASK_ID",TASK_ID)
  const { getTaskStatus, registerTask, getTaskData, getConnectionStatus } =
    useTaskStatus();

  const { accountId, clientName, accountName } = useParams();
  const {user}= useUser();
  console.log("ReachOutKitSCRO",contactDetail)
  const showBanner = useBanner();

  const [showModal, setShowModal] = useState(false);
  const [mtnModalOpen, setMtnModalOpen] = useState(false);
  const [selectedOpportunity, setSelectedOpportunity] = useState(null);
  const [customOpportunityName, setCustomOpportunityName] = useState("");
  const [customOpportunityDescription, setCustomOpportunityDescription] = useState("");
  const [productsList,setProducts]=useState([])
  const [campaignDate,setCampaignDate]=useState();
  const [campaignName,setCampaignName]=useState();
  const [campaignContext,setCampaignContext]=useState();
    const [selectedProducts, setSelectedProducts] = useState([])
    const [campaignSubmitting,setCampaignSubmitting]=useState(false);
  const [input, setInput] = useState("");
  // const isConnected = getConnectionStatus("task-123");
  const taskStatus = getTaskStatus(TASK_ID);
  const taskData = getTaskData(TASK_ID);
  const isConnected = getConnectionStatus(TASK_ID);
  const mapToOption = (arr) => arr.map((val) => ({ label: val, value: val }));
  const resetState = () => {
    setSelectedOpportunity(null);
    setCustomOpportunityName("");
    setCustomOpportunityDescription("");
    setInput("");
    setShowModal(false);
  };

  useEffect(() => {

    console.log("ReachOutKitSCRO",localStorage.getItem(`tro_sidecard_reachout_${contactId}_${oppId}`))
    registerTask(`tro_sidecard_reachout_${contactId}_${oppId}`,localStorage.getItem(`tro_sidecard_reachout_${contactId}_${oppId}`))
    
  }, [contactId,oppId])
  
  const handleGenerate = async () => {

    const data = {
      client: clientName,
      account: accountName,
      contact_name: contact_name,
      opportunity_name: selectedOpportunity?.opportunity_name || customOpportunityName,
      opportunity_description:
        selectedOpportunity?.opportunity_description || customOpportunityDescription,
      linkedin_url:linkedInUrl,
      seller_job_title:user?.designation,
      seller_company:user?.company_name,
      seller_company_website:"",
      custom_instructions: input,
      contact_job_title:contactJobTitle
    };

    try {
      const resp = await iq_api_v2.post(
        "touch_nurture_sequence_v1",
        {},
        { params: data }
      );

      registerTask(
        `tro_sidecard_reachout_${contactId}_${oppId}`,
        `${WSS_URL}/${resp?.data?.task_id}`
      );
      // alert("Contact will be created shortly!");
      resetState();
    } catch (err) {
      // alert(`❗ ${err?.response?.data?.message || "Something went wrong"}`);
      console.log("err",err)
    }
  };

 const parseContact = useCallback((c) => {
    // Prepare location parts safely
    const city = c?.city?.trim();
    const country = c?.country?.trim();

    let location = "";
    if (city && country) {
      location = `${city}, ${country}`;
    } else if (city) {
      location = city;
    } else if (country) {
      location = country;
    } else {
      location = "N/A"; // or leave it as an empty string ""
    }
    return {
      id: c?._id || c?.id,
      name: c?.name || `${c?.first_name || ""} ${c?.last_name || ""}`.trim(),
      title: c?.title || "",
      location,
      email: c?.email !== "email_not_unlocked@domain.com" || c?.email != "" ? c?.email : null,
      linkedin_url: c?.linkedin_url || "",
      caseType: c?.caseType,
      city: city,
      country: country,
      headline: c?.headline || "",
    };
  }, []);



  const handleStartAutoNurtureFromReachOut = async(e)=>{
    setCampaignSubmitting(true)
    e.preventDefault();
    e.stopPropagation();
     try {
      const dataObj = {
            title: campaignName,
            start_date: formatDateToYMD(campaignDate),
            context: campaignContext,
            time_gap: 5,
            user_id: user?.id,
            user_name: user?.firstname + " " + user?.lastname,
            user_email: user?.email,
            client: user?.company_name,
            account: accountName,
            products: selectedProducts,
            opportunity_id:selectedOpportunity?._id
          };
          const resp = await createCampaign(dataObj);
          if (resp?.success==200) {
            
                const addContactResp = await addContactsToCampaign(
                  resp?.campaign_id,
                  [contactDetail].map(parseContact),{}
                );
          const emailsList = [];

          for (let i = 1; i <= 3; i++) {
            const subject = taskData.result[`email_${i}_subject`];
            const bodycontent = taskData.result[`email_${i}_body`];
            const contact_id = addContactResp?.inserted?.[0]?._id;

            const date = new Date(campaignDate); // assuming campaignDate is a string or Date object
            date.setDate(date.getDate() + (i * 3)); // 0, 3, 6 days

            const formattedDate = date.toISOString().split("T")[0]; // format: YYYY-MM-DD

            emailsList.push({
              subject,
              bodycontent,
              date_to_send: formattedDate,
              contact_id
            });
          }


               const tempResp = await addTempaltesToCampaign(resp?.campaign_id, emailsList);
                if(tempResp?.success==200){  showBanner({
                    message: "Please Review The Campaign in Auto Nurture!",
                    title: "Alert",
                    type: "success",
                    duration: 10000,
                });}
          }
     } catch (error) {
      showBanner({
                    message: "Error While Creating Campaign",
                    title: "Alert",
                    type: "error",
                    duration: 10000,
                });
      console.log("error",error)
     }
     finally{
      setCampaignSubmitting(false)
      setShowMoreModal(false)
     }
          
    

  }


    useEffect(() => {
      async function fetchClientData() {
        try {
          const userId = user?.id; // ensure this is set
          const clientName = user?.company_name;
          const currentRole = user?.role_key || "CLIENT"; // or get from auth
  
          if (!userId || !clientName) {
            console.warn("Missing userId or clientName");
            return;
          }
  
          const data = await userClientData(userId, clientName, currentRole);
  
          if (Array.isArray(data?.products)) {
            setProducts(data.products);
          } else {
            console.warn("Unexpected product structure:", data);
            setProducts([]);
          }
        } catch (error) {
          console.error("Failed to fetch client data:", error);
        }
      }
  
      fetchClientData();
    }, [selectedOpportunity?._id]);

  useEffect(() => {
    console.log("taskData", taskData, isConnected);
  }, [taskData, isConnected]);

  if (taskData?.status == "pending" && isConnected) {
    return (
      <div className="reachout_kit_wrapper">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height:"30rem"
          }}
        >
          <GeneratingLoader />
        </div>
      </div>
    );
  }

  return (
    <div
      className="reachout_kit_wrapper text-center"
      key={contactId || new Date()?.toLocaleString()}
    >
      <span
        style={{
          display: "flex",
          justifyContent: taskData?.result ? "space-between" : "center",
        }}
      >
        <button
          className="generate_btn new_generate_kit"
          onClick={() => setShowModal(true)}
        >
          Generate Reachout Kit
        </button>
        {taskData?.result && (
          <button
            className="generate_btn new_generate_kit"
            onClick={() => setMtnModalOpen(true)}
          >
            Start Auto Nurture
          </button>
        )}
      </span>
      {taskData?.result && (
        <>
          {/* EMAIL REACHOUT TITLE */}
          <h5 className="mt-1 mb-1 text-start reachout_title_new">
            Email Reachout
          </h5>
          {[1, 2, 3].map((i) => (
            <Accordion key={`email-${i}`} defaultActiveKey="0">
              <Accordion.Item eventKey="0" className="reachout_accordian">
                <Accordion.Header className="reachout_accordian_header">
                  <div className="accord_header">
                    <div className="d-flex top_accord">
                      <span className="accrod_head_span ">
                        Touch {i} - Email
                      </span>
                    </div>
                    <div className="dots_class"></div>
                  </div>
                </Accordion.Header>
                <Accordion.Body className="reachout_accordian_body text-start">
                  <p>
                    <strong>
                      Subject: {taskData.result[`email_${i}_subject`]}{" "}
                    </strong>
                  </p>
                  <p>
                    {" "}
                    <ReactMarkdown>
                      {taskData.result[`email_${i}_body`]}
                    </ReactMarkdown>
                  </p>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          ))}

          {/* LINKEDIN REACHOUT TITLE */}
          {/* <h5 className="mt-1 mb-1 text-start reachout_title_new">LinkedIn Reachout</h5>
    {[{idx:1,infoTxt:'(This message could also be sent as a personalized note when sending the connection request)'}, 
    {idx:2,infoTxt:"(Send 3 days after connection acceptance)"}, 
    {idx:3,infoTxt:"(Send 1 week after Message 2)"}, 
  ].map((i) => (
      <Accordion key={`linkedin-${i?.idx}`} defaultActiveKey="0">
        <Accordion.Item eventKey="0" className="reachout_accordian"> 
          <Accordion.Header className="reachout_accordian_header">
            <div className="accord_header">
              <div className="d-flex top_accord">
                <span className="accrod_head_span">
                  Touch {i?.idx} - LinkedIn
                </span>

              <span className=" text-secondary small ml-2">{i?.infoTxt}</span>
              </div>
              <div className="dots_class"></div>
            </div>
          </Accordion.Header>
          <Accordion.Body className="reachout_accordian_body text-start">
            <p><ReactMarkdown>{taskData.result[`linkedin_message_${i?.idx}`]}</ReactMarkdown></p>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    ))} */}
        </>
      )}

      {showModal && (
        <div className="reachout-modal">
          <div className="modal-content reachout_modal_content">
            <h4 className="modal_opp_top_head">
              Select Opportunity or Add Manually
            </h4>

            {!customOpportunityName && !customOpportunityDescription && (
              <>
                <select
                  className="modal-select aesthetic-dropdown mb-2"
                  onChange={(e) => {
                    const selected = opportunity_details?.find(
                      (item) => item._id === e.target.value
                    );
                    setSelectedOpportunity(selected);
                    setCustomOpportunityName("");
                    setCustomOpportunityDescription("");
                    console.log("selected", selected);
                  }}
                  value={selectedOpportunity?._id || ""}
                >
                  <option value="">-- Select Opportunity --</option>
                  {opportunity_details?.map((opp) => (
                    <option key={opp._id} value={opp._id}>
                      {opp.opportunity_name}
                    </option>
                  ))}
                </select>
                <hr />
                {!selectedOpportunity && (
                  <h5 className="modal_opp_top_head mt-1">
                    Or Enter Custom Opportunity
                  </h5>
                )}
              </>
            )}

            {!selectedOpportunity && (
              <>
                <input
                  type="text"
                  className="modal-input mb-3"
                  placeholder="Opportunity Name"
                  value={customOpportunityName}
                  onChange={(e) => {
                    setCustomOpportunityName(e.target.value);
                    setSelectedOpportunity(null);
                  }}
                />

                <textarea
                  className="modal-textarea mb-3"
                  placeholder="Opportunity Description"
                  value={customOpportunityDescription}
                  onChange={(e) => {
                    setCustomOpportunityDescription(e.target.value);
                    setSelectedOpportunity(null);
                  }}
                />
              </>
            )}

            <textarea
              className="modal-textarea"
              placeholder="Custom Instructions"
              value={input}
              onChange={(e) => setInput(e.target.value)}
            />

            <div className="modal-actions">
              <button className="cancel_modal_btn" onClick={resetState}>
                Cancel
              </button>
              <button className="genrate_modal_btn" onClick={handleGenerate}>
                Generate
              </button>
            </div>
          </div>
        </div>
      )}

      {mtnModalOpen && (
        <div className="reachout-modal">
          <div className="modal-content reachout_modal_content">
            <h4 className="modal_opp_top_head">Select Date for Nurture</h4>
            <hr/>

            <SimpleDateField
              disablePastDates={true}
              label="Campaign Start Date"
              labelPosition="top-left"
              value={campaignDate}
              showBelow={true}
              onChange={(val) => {
                setCampaignDate(val);
                // setCurrentCampDetails((prev) => ({
                //   ...prev,
                //   startDate: val,
                // }));
              }}
              minDate={new Date(2020, 0, 1)}
              maxDate={new Date(2030, 11, 31)}
              disableWeekends
              customWidth="100%"
            />
            <span style={{ marginTop: "1.5vh" }}>
              <SimpleTextField
                label="Camapign Name"
                value={campaignName}
                setValue={(e) => {
                  setCampaignName(e.target.value);
                }}
              />
            </span>
            <label className="nccs-rcho-field">
              <div className="nccs-rcho-field-header"> <span className="nccs-rcho-label">
                What Are You Selling ?
              </span>
              <div className="nccs-rcho-field_selected_count">
                  {selectedProducts?.length > 0 && (
                    <>{selectedProducts?.length} Selected</>
                  )}
                </div></div>
             
              <span
                className="what_selling_wrapper-rcho"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: "1rem",
                  position: "relative",
                }}
              >
                <SearchOrAddDropdown
                  placeholder="Choose One or More Products"
                  options={mapToOption([
                    ...new Set(productsList.map((p) => p?.product_name)),
                  ])}
                  value={selectedProducts}
                  onChange={setSelectedProducts} // placeholder text
                  mode="multiple"
                  showCount={false}
                  noEditPlaceHolder={true}
                />

                
              </span>
            </label>

            <span style={{ marginTop: "1.5vh" }}>
              <SimpleTextAreaField
                label="Campaign Context"
                placeholder="Describe the purpose and tone for this campaign…"
                rows={5}
                value={campaignContext}
                onChange={(e) => setCampaignContext(e.target.value)}
                customWidth="100%"
              />
            </span>


            <div className="modal-actions">
              <button
                className="cancel_modal_btn"
                onClick={(e) => {
                  e.preventDefault();
                  setMtnModalOpen(false);
                }}
              >
                Cancel
              </button>
              {/* <button
                className="genrate_modal_btn"
                onClick={handleStartAutoNurtureFromReachOut}
              >
                Start Nurture
              </button> */}
               <SimpleThemedButton isLoading={campaignSubmitting} loaderTxt="Submitting" onBtnClick={handleStartAutoNurtureFromReachOut} buttonText="Start Nurture" btnDisabled={campaignSubmitting}/>
            </div>
           
          </div>
        </div>
      )}
    </div>
  );
}

export default ReachOutKitSCROV1;
